import { pinia } from './pinia';

class StoreManager {
  constructor() {
    this.storesMap = new Map();
  }

  setup(app) {
    this.registerPinia(app);
    this.loadStoreModules();
    this.exposeStores(app);
  }

  registerPinia(app) {
    app.use(pinia);
    pinia._app = app;
  }

  loadStoreModules() {
    const storeModules = import.meta.glob('/src/app/features/**/store.js', {
      eager: true
    });

    for (const module of Object.values(storeModules)) {
      if (module?.default) {
        const StoreClass = module.default;
        const storeInstance = new StoreClass();
        const storeId = storeInstance.id || 'unknown';
        this.storesMap.set(storeId, storeInstance);
        console.log(`Store enregistré : ${storeId}`);
      }
    }
  }

  exposeStores(app) {
    const storesObj = Object.fromEntries(this.storesMap);
    app.config.globalProperties.$stores = storesObj;
    app.config.globalProperties.useStore = (name) =>
      this.storesMap.get(name) || null;
    // Also expose to window for direct access
    window.$stores = storesObj;
  }

  getStore(name) {
    return this.storesMap.get(name) || null;
  }
}

const storeManager = new StoreManager();

function setupStores(app) {
  storeManager.setup(app);
}

function getStore(name) {
  return storeManager.getStore(name);
}

export { setupStores, getStore };
